import { SelectMenu } from '@scale/scaleui';
import { enumValues } from '@scale/shared/utils';
import { ChatPipelineRoutingDestination } from '@scale/shared-types';
import BuilderHint from 'react-scale/corp/components/QM/taskTemplatesEditor/BuilderHint';

interface SingleDestinationRoutingReviewLevelBuilderProps {
  name: string;
  existingValue?: string;
  updateProperty: (arg: string) => void;
  required?: boolean;
  hint?: string;
}

const SingleDestinationRoutingReviewLevelBuilder = ({
  existingValue,
  updateProperty,
  name,
  required,
  hint,
}: SingleDestinationRoutingReviewLevelBuilderProps) => {
  return (
    <div>
      <label className="block text-sm font-medium leading-6 text-neutral-700">
        {name}
        {required && <span className="text-danger-400">*</span>}
      </label>
      <div className="flex flex-row">
        <SelectMenu
          className="min-w-[135px]"
          options={enumValues(ChatPipelineRoutingDestination).map(s => ({
            id: s,
            name: s,
          }))}
          selectedOptionId={existingValue as string}
          setSelected={updateProperty}
        />
        {hint && <BuilderHint name={name} hint={hint} />}
      </div>
    </div>
  );
};

export default SingleDestinationRoutingReviewLevelBuilder;
